import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Textarea,
  Tfoot,
  useToast,
  Grid,
  GridItem,
  Spinner
} from '@chakra-ui/react';
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';

const TesoComprobantesGrilla = () => {
  const [extbcoModalOpen, setExtbcoModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(Array(5).fill(null));
  const [saldo, setSaldo] = useState(Array(5).fill(0));
  const [observaciones, setObservaciones] = useState('');
  const [totalSaldo, setTotalSaldo] = useState(0);
  const [fechaCbte, setFechaCbte] = useState('');
  const [fechaExtracto, setFechaExtracto] = useState('');
  const [items, setItems] = useState([]);
  const [estadoItems, setEstadoItems] = useState({});
  const [saldosItems, setSaldosItems] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemModalOpen, setItemModalOpen] = useState(false);
  const [conceptos, setCuentas] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [lopsModalOpen, setLopsModalOpen] = useState(false);
  const [lopsSaldo, setLopsSaldo] = useState(0);
  const [itemRegistros, setItemRegistros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const toast = useToast(); // Para mostrar mensajes emergentes
  const history = useHistory(); // Para manejar la navegación

  useEffect(() => {
    fetchItems();
  }, []); // Ejecuta esto solo una vez al montar el componente.

  useEffect(() => {
    const fetchEstadoYSaldo = async () => {
      const promises = items.map(async (item) => {
        const id = item.id_comprobante_item;

        try {
          // Fetch estado
          const estadoURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${id}/estado-conciliacion`;
          const estadoResponse = await fetch(estadoURL, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": localStorage.getItem("token"),
            },
          });

          const estadoData = estadoResponse.ok ? await estadoResponse.json() : { estado: "Error" };

          // Fetch saldo
          const saldoURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${id}/saldo`;
          const saldoResponse = await fetch(saldoURL, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": localStorage.getItem("token"),
            },
          });

          const saldoData = saldoResponse.ok ? await saldoResponse.json() : { saldo: "Error" };


          return { id, estado: estadoData.estado, saldo: saldoData.saldo };
        } catch (error) {
          console.error(`Error fetching data for item ${id}:`, error);
          return { id, estado: "Error", saldo: "Error" };
        }
      });

      // Espera a que todas las promesas terminen y actualiza el estado
      const results = await Promise.all(promises);
      const nuevosEstados = {};
      const nuevosSaldos = {};

      results.forEach(({ id, estado, saldo }) => {
        nuevosEstados[id] = estado;
        nuevosSaldos[id] = saldo;
      });

      setEstadoItems((prev) => ({ ...prev, ...nuevosEstados }));
      setSaldosItems((prev) => ({ ...prev, ...nuevosSaldos }));
    };

    if (items.length > 0) {
      fetchEstadoYSaldo();
    }
  }, [items]); // ESTADO Y SALDO ITEMS - Ejecuta esto cuando cambien los items 

  useEffect(() => {
    async function fetchConceptos() {
      try {

        const baseURL = `${process.env.REACT_APP_API_URL}/conceptos/extbco`;
        const response = await fetch(baseURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem("token"),
          },
        });

        if (response.ok) {
          const result = await response.json();
          setCuentas(result);
        } else {
          console.error("Error fetching conceptos:", response.statusText);
        }

      } catch (error) {
        console.error('Error fetching conceptos:', error);
      }
    }
    fetchConceptos();
  }, []); // CONCEPTOS

  const handleFileUpload = (index, file, isLops = false) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const csvData = event.target.result;

      Papa.parse(csvData, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          let data = result.data;

          // Invertir el array para que el saldo se calcule desde el registro más antiguo al más reciente
          data = data.slice().reverse();

          // Función para limpiar y convertir valores monetarios
          const parseMonetaryValue = (value) => {
            // Verificar si el valor solo contiene números y/o un punto
            if (/^\d+(\.\d+)?$/.test(value)) {
              return parseFloat(value);
            }

            if (typeof value !== "string") {
              throw new Error("La entrada debe ser string");
            }

            // Eliminar el símbolo de dólar y los paréntesis (si los hay)
            let sanitizedInput = value.replace(/[\$\(\)]/g, '');

            // Si el valor ya es numérico, devolverlo tal cual
            if (typeof value === "number") {
              return value;
            }

            let numericValue;

            if (typeof value === "string") {
              // Eliminar el símbolo de dólar y los paréntesis (si los hay)
              let sanitizedInput = value.replace(/[\$\(\)]/g, '');

              // Identificar si el valor es negativo (puede ser con paréntesis o guion)
              const isNegative = value.includes('(') || value.includes('-');

              // Eliminar puntos como separadores de miles y cambiar comas por puntos
              sanitizedInput = sanitizedInput
                .replace(/\./g, '') // Eliminar puntos
                .replace(/,/g, '.'); // Cambiar comas por puntos

              // Parsear el número
              numericValue = parseFloat(sanitizedInput);

              if (isNaN(numericValue)) {
                throw new Error("Formato inválido para valor monetario.");
              }

              // Si es negativo, cambiar el signo
              if (isNegative) {
                numericValue = -Math.abs(numericValue);
              }
            } else {
              throw new Error("Tipo de valor no soportado.");
            }

            return numericValue;
          };

          if (isLops) {
            let saldoAcumulado = 0;
            data.forEach(row => {
              const importe = parseMonetaryValue(row['Importe']);
              saldoAcumulado += importe;
            });
            setLopsSaldo(saldoAcumulado);
            const newFiles = [...selectedFiles];
            newFiles[0] = { file, id_concepto: null };
            setSelectedFiles(newFiles);
          } else {
            // Extraer el último saldo (ahora es el saldo de la última fila después de invertir)
            const lastRow = data[data.length - 1];
            let lastSaldo = lastRow?.Saldo;
            if (typeof lastRow?.Saldo === "string") {
              lastSaldo = parseMonetaryValue(lastRow?.Saldo);
            }

            const newSaldo = [...saldo];
            newSaldo[index] = lastSaldo || 0;
            setSaldo(newSaldo);
            setTotalSaldo(newSaldo.reduce((acc, curr) => acc + curr, 0));

            const newFiles = [...selectedFiles];
            newFiles[index] = { file, id_concepto: conceptos[index]?.id_concepto };
            setSelectedFiles(newFiles);
          }
        },
        error: (error) => {
          console.error("Error al procesar el archivo CSV:", error);
          toast({
            title: "Error al procesar archivo",
            description: `No se pudo leer el archivo. Verifica su formato.`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        },
      });
    };

    reader.readAsText(file);
  };

  // Funcion para guardar un comprobante EXTBCO
  const handleSaveExtbco = async () => {
    setIsLoading(true); // Inicia el estado de carga
    const formData = new FormData();
    selectedFiles.forEach((entry) => {
      if (entry && entry.file) {
        formData.append('archivos', entry.file);
        formData.append('ids_concepto', entry.id_concepto);
      }
    });
    formData.append('fecha_emision', fechaCbte);
    formData.append('fecha_archivos', fechaExtracto);
    formData.append('id_empresa', 1);
    formData.append('pvt_numero', "00001");
    formData.append('observaciones', observaciones);

    try {

      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/extbco`;

      const response = await fetch(baseURL, {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
        body: formData,
      });

      if (response.ok) {
        toast({
          title: 'Guardado con éxito.',
          description: 'El EXTBCO fue guardado correctamente.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        setExtbcoModalOpen(false);
        fetchItems();
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error saving EXTBCO:", error);
      toast({
        title: "Error al guardar.",
        description: `No se pudo guardar el EXTBCO.`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false); // Finaliza el estado de carga
    }
  };

  // Funcion para guardar un comprobante LOPS
  const handleSaveLops = async () => {
    setIsLoading(true); // Inicia el estado de carga
    const formData = new FormData();
    if (selectedFiles[0] && selectedFiles[0].file) {
      formData.append('file', selectedFiles[0].file);
    }
    formData.append('fecha_emision', fechaCbte);
    formData.append('fecha_archivos', fechaExtracto);
    formData.append('observaciones', observaciones);

    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/lops`;

      const response = await fetch(baseURL, {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
        body: formData,
      });

      if (response.ok) {
        toast({
          title: 'Guardado con éxito.',
          description: 'El LOPS fue guardado correctamente.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        setLopsModalOpen(false);
        fetchItems();
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error saving LOPS:", error);
      toast({
        title: "Error al guardar.",
        description: `No se pudo guardar el LOPS.`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false); // Finaliza el estado de carga
    }
  };

  // Función para obtener los items
  const fetchItems = async (page = 1) => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items?page=${page}`;
      const response = await fetch(baseURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const result = await response.json();
        setItems(result.items);
        setTotalPages(result.totalPages);
        setCurrentPage(result.currentPage);
      } else {
        console.error("Error fetching items:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  // Funcion para eliminar un item
  const handleDelete = async (id) => {
    const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${id}`;
    try {
      const response = await fetch(baseURL, {
        method: "DELETE",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        // Filtra el item eliminado del estado
        setItems((prev) =>
          prev.filter((item) => item.id_comprobante_item !== id)
        );
        toast({
          title: "Eliminado con éxito.",
          description: `El item con ID ${id} fue eliminado.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      toast({
        title: "Error al eliminar.",
        description: `No se pudo eliminar el item con ID ${id}.`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Funcion para abrir modal de eliminación
  const confirmDelete = (id) => {
    setItemToDelete(id);
    setDeleteModalOpen(true);
  };

  // Funcion para ver un item
  const handleViewItem = async (item) => {
    setSelectedItem(item);
    setItemModalOpen(true);
    const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${item.id_comprobante_item}/registros`;
    try {
      const response = await fetch(baseURL, {
        method: "GET",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
      });

      const data = await response.json();
      setItemRegistros(data);
    } catch (error) {
      console.error('Error fetching registros:', error);
    }
  };

  // Funcion para ordenar items
  const handleSort = (key) => {
    let order = "asc";
    if (sortKey === key && sortOrder === "asc") {
      order = "desc";
    }
    setSortKey(key);
    setSortOrder(order);

    const sortedItems = [...items].sort((a, b) => {
      const valA = key.includes(".") ? key.split(".").reduce((o, k) => o?.[k], a) : a[key];
      const valB = key.includes(".") ? key.split(".").reduce((o, k) => o?.[k], b) : b[key];

      const numA = !isNaN(valA) ? Number(valA) : null;
      const numB = !isNaN(valB) ? Number(valB) : null;

      if (numA !== null && numB !== null) {
        // Comparar como números
        return order === "asc" ? numA - numB : numB - numA;
      } else if (typeof valA === "string" && typeof valB === "string") {
        // Comparar como cadenas
        return order === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
      }
      return 0; // Si los valores no son comparables, los dejamos como están
    });
    setItems(sortedItems);
  };

  const resetExtbcoModal = () => {
    setSelectedFiles(Array(5).fill(null));
    setSaldo(Array(5).fill(0));
    setObservaciones('');
    setTotalSaldo(0);
    setFechaCbte('');
    setFechaExtracto('');
  };
  
  const resetLopsModal = () => {
    setSelectedFiles(Array(5).fill(null));
    setLopsSaldo(0);
    setObservaciones('');
    setFechaCbte('');
    setFechaExtracto('');
  };

  const openExtbcoModal = () => {
    resetExtbcoModal();
    setExtbcoModalOpen(true);
  };
  
  const openLopsModal = () => {
    resetLopsModal();
    setLopsModalOpen(true);
  };

  return (
    <Box p={4} mt="22%">

      {/* Botones para modal */}
      <Flex gap={4} mb={6}>
        <Button colorScheme="linkedin" onClick={openExtbcoModal}>
          Nuevo EXTBCO
        </Button>
        <Button colorScheme="blue" onClick={openLopsModal}>
          Nuevo LOPS
        </Button>
        <Button colorScheme="teal" onClick={() => history.push('/admin/conciliarops')}>
          Conciliar OPS
        </Button>
      </Flex>

      {/* Grid para items */}
      <Table size="md" variant="striped" colorScheme="gray" fontSize="sm">
        <Thead>
          <Tr>
            <Th onClick={() => handleSort("id_comprobante_item")}>
              ID Item {sortKey === "id_comprobante_item" && (sortOrder === "asc" ? "↑" : "↓")}
            </Th>
            <Th onClick={() => handleSort("fecha_archivos")}>
              Fecha Extracto {sortKey === "fecha_archivos" && (sortOrder === "asc" ? "↑" : "↓")}
            </Th>
            <Th onClick={() => handleSort("id_empresa")}>
              Cta Bco {sortKey === "id_empresa" && (sortOrder === "asc" ? "↑" : "↓")}
            </Th>
            <Th onClick={() => handleSort("fecha_emision")}>
              Fecha Cbte {sortKey === "fecha_emision" && (sortOrder === "asc" ? "↑" : "↓")}
            </Th>
            <Th onClick={() => handleSort("id_comprobante")}>
              Cbte {sortKey === "id_comprobante" && (sortOrder === "asc" ? "↑" : "↓")}
            </Th>
            <Th onClick={() => handleSort("total")}>
              Saldo {sortKey === "total" && (sortOrder === "asc" ? "↑" : "↓")}
            </Th>
            <Th>Estado</Th>
            <Th>Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item, index) => (
            <Tr key={index}>
              <Td>{item.id_comprobante_item}</Td>
              <Td>{item.comprobantes.fecha_archivos}</Td>
              <Td>{conceptos.find(concepto => concepto.id_concepto === item.id_concepto)?.descripcion || "GLM"}</Td>
              <Td>{item.comprobantes.fecha_emision}</Td>
              <Td>{`${item.comprobantes.tco_codigo} N° ${item.id_comprobante}`}</Td>
              <Td style={{ textAlign: "right" }}>
                {/* Mostrar SIEMPRE el saldo original del comprobante_item */}
                {item.comprobantes.total !== undefined && item.comprobantes.total !== null
                  ? Number(item.comprobantes.total).toFixed(2)
                  : "0.00"}
              </Td>
              <Td>{estadoItems[item.id_comprobante_item] || "Cargando..."}</Td>
              <Td>
                <Button size="sm" colorScheme="teal" mr={2} onClick={() => handleViewItem(item)}>
                  Ver
                </Button>
                <Button size="sm" colorScheme="red" onClick={() => confirmDelete(item.id_comprobante_item)}>
                  Eliminar
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {/* Paginación */}
      <Flex justifyContent="space-between" mt={4}>
        <Button
          onClick={() => fetchItems(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Anterior
        </Button>
        <Box>
          Página {currentPage} de {totalPages}
        </Box>
        <Button
          onClick={() => fetchItems(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Siguiente
        </Button>
      </Flex>

      {/* CREAR EXTBCO Modal */}
      <Modal isOpen={extbcoModalOpen} onClose={() => { resetExtbcoModal(); setExtbcoModalOpen(false); }} size="xl" >
        <ModalOverlay />
        <ModalContent maxWidth="50%">
          <ModalHeader>Nuevo EXTBCO</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap={4}>
              <Box>
                <label>Fecha Cbte:</label>
                <Input type="date" value={fechaCbte} onChange={(e) => setFechaCbte(e.target.value)} />
              </Box>
              <Box>
                <label>Fecha Extracto:</label>
                <Input type="date" value={fechaExtracto} onChange={(e) => setFechaExtracto(e.target.value)} />
              </Box>

              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th></Th>
                    <Th></Th>
                    <Th></Th>
                    <Th>Saldo</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {conceptos.map((concepto, index) => (
                    <Tr key={concepto.id_concepto}>
                      <Td>{index + 1}</Td>
                      <Td>{concepto.descripcion}</Td>
                      <Td>
                        <Input
                          type="file"
                          accept=".csv"
                          onChange={(e) => handleFileUpload(index, e.target.files[0])}
                        />
                      </Td>
                      <Td>{saldo[index]?.toFixed(2) || "0.00"}</Td>
                    </Tr>
                  ))}
                </Tbody>
                <Tfoot>
                  <Tr>
                    <Td colSpan={3}>Total</Td>
                    <Td>{totalSaldo.toFixed(2)}</Td>
                  </Tr>
                </Tfoot>
              </Table>

              <Box>
                <label>Observaciones:</label>
                <Textarea
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" onClick={handleSaveExtbco} mr={3}>
              Guardar
            </Button>
            <Button onClick={() => setExtbcoModalOpen(false)}>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* CREAR LOPS Modal */}
      <Modal isOpen={lopsModalOpen} onClose={() => { resetLopsModal(); setLopsModalOpen(false); }} size="xl">
        <ModalOverlay />
        <ModalContent maxWidth="50%">
          <ModalHeader>Nuevo LOPS</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap={4}>
              <Box>
                <label>Fecha Cbte:</label>
                <Input type="date" value={fechaCbte} onChange={(e) => setFechaCbte(e.target.value)} />
              </Box>
              <Box>
                <label>Fecha Orden de Pago:</label>
                <Input type="date" value={fechaExtracto} onChange={(e) => setFechaExtracto(e.target.value)} />
              </Box>
              <Box>
                <label>Observaciones:</label>
                <Textarea value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
              </Box>
              <Box>
                <label>Archivo CSV:</label>
                <Input type="file" accept=".csv" onChange={(e) => handleFileUpload(0, e.target.files[0], true)} />
              </Box>
              <Box>
                <label>Saldo:</label>
                <Input type="text" value={lopsSaldo.toFixed(2)} readOnly />
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" onClick={handleSaveLops} mr={3}>
              Guardar
            </Button>
            <Button onClick={() => setLopsModalOpen(false)}>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* VER ITEM Modal */}
      <Modal isOpen={itemModalOpen} onClose={() => setItemModalOpen(false)} size="full">
        <ModalOverlay />
        <ModalContent maxWidth="90%" maxHeight="90vh" height="90vh">
          <ModalHeader>Información del Ítem </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflowY="auto">
            {selectedItem && (
              <Box>
                <Heading as="h3" size="md">ID {selectedItem.id_comprobante_item} </Heading>
                <br></br>
                <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                  <GridItem>
                    <Box bg="blue.200" p={4} borderRadius="md" boxShadow="md">
                      <p><strong>Concepto:</strong> {conceptos.find(concepto => concepto.id_concepto === selectedItem.id_concepto)?.descripcion || "GLM"}</p>
                    </Box>
                  </GridItem>
                  <GridItem>
                    <Box bg="blue.200" p={4} borderRadius="md" boxShadow="md">
                      <p>
                        <strong>Saldo:</strong> $ {
                          selectedItem.comprobantes && selectedItem.comprobantes.total !== undefined && selectedItem.comprobantes.total !== null
                            ? Number(selectedItem.comprobantes.total).toFixed(2)
                            : "0.00"
                        }
                      </p>
                    </Box>
                  </GridItem>
                  <GridItem>
                    <Box bg="blue.200" p={4} borderRadius="md" boxShadow="md">
                      <p><strong>Estado:</strong> {estadoItems[selectedItem.id_comprobante_item] || "Cargando..."}</p>
                    </Box>
                  </GridItem>
                </Grid>
                <br></br>
                <Grid templateColumns="repeat(3, 1fr)" gap={6} borderRadius="md" border="1px solid gray">
                  <GridItem>
                    <Box p={4}>
                      <p><strong>ID Comprobante:</strong> {selectedItem.id_comprobante}</p>
                      <p><strong>TCO Código:</strong> {selectedItem.comprobantes.tco_codigo}</p>
                      <p><strong>Letra Comprobante:</strong> {selectedItem.comprobantes.letra_comprobante}</p>
                    </Box>
                  </GridItem>
                  <GridItem>
                    <Box p={4}>
                      <p><strong>Fecha Comprobante:</strong> {selectedItem.comprobantes.fecha_emision}</p>
                      <p><strong>Fecha Extracto:</strong> {selectedItem.comprobantes.fecha_archivos}</p>
                    </Box>
                  </GridItem>
                  <GridItem>
                    <Box p={4}>
                      <p><strong>ID Usuario:</strong> {selectedItem.comprobantes.id_usuario}</p>
                      <p><strong>Total:</strong> $ {selectedItem.comprobantes.total}</p>
                    </Box>
                  </GridItem>
                </Grid>
                <br></br>
                <Box bg="gray.100" p={4} borderRadius="md">
                  <p><strong>Observaciones:</strong> {selectedItem.comprobantes.observaciones}</p>
                </Box>
                <br></br>
                <hr></hr>
                <br></br>
                <Heading as="h3" size="sm">Registros</Heading>
                <Table size="sm" variant="striped" colorScheme="gray" mt={4}>
                  <Thead>
                    <Tr>
                      <Th
                        cursor="pointer"
                        onClick={() => {
                          // Alternar el orden de los registros
                          setItemRegistros((prev) => [...prev].reverse());
                        }}
                      >
                        Orden ↕
                      </Th>
                      <Th>Fecha Movimiento</Th>
                      <Th>Fecha Valor</Th>
                      <Th flex="1">Descripción</Th>
                      <Th>Num Comprobante</Th>
                      <Th textAlign="center" whiteSpace="nowrap" minWidth="100px">Débito</Th>
                      <Th textAlign="center" whiteSpace="nowrap" minWidth="100px">Crédito</Th>
                      <Th textAlign="center" whiteSpace="nowrap" minWidth="100px">Saldo</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {itemRegistros.map((registro, index) => (
                      <Tr key={index}>
                        <Td>{registro.num_orden}</Td>
                        <Td>{new Date(registro.fecha_movimiento).toLocaleDateString('es-ES')}</Td>
                        <Td>{new Date(registro.fecha_valor).toLocaleDateString('es-ES')}</Td>
                        <Td flex="1">{registro.descripcion}</Td>
                        <Td>{registro.num_comprobante}</Td>
                        <Td textAlign="right" whiteSpace="nowrap">
                          $ {typeof registro.debito === "number" ? registro.debito.toFixed(2) : (registro.debito ? Number(registro.debito).toFixed(2) : "0.00")}
                        </Td>
                        <Td textAlign="right" whiteSpace="nowrap">
                          $ {typeof registro.credito === "number" ? registro.credito.toFixed(2) : (registro.credito ? Number(registro.credito).toFixed(2) : "0.00")}
                        </Td>
                        <Td textAlign="right" whiteSpace="nowrap">
                          $ {typeof registro.saldo === "number" ? registro.saldo.toFixed(2) : (registro.saldo ? Number(registro.saldo).toFixed(2) : "0.00")}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={() => setItemModalOpen(false)}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* ELIMINAR ITEM Modal */}
      <Modal isOpen={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirmar Eliminación</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            ¿Estás seguro de que deseas eliminar el ítem con ID {itemToDelete}?
            Esta acción no se puede deshacer.
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red"
              onClick={() => {
                handleDelete(itemToDelete);
                setDeleteModalOpen(false);
              }}
              mr={3}>
              Confirmar
            </Button>
            <Button onClick={() => setDeleteModalOpen(false)}>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* CARGANDO Modal */}
      <Modal isOpen={isLoading} onClose={() => { }} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Espere, cargando...</ModalHeader>
          <ModalBody>
            <Spinner size="xl" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TesoComprobantesGrilla;